import type { ExperimentalQueries } from '../__types__/ExperimentalQueries'; //eslint-disable-line no-restricted-imports
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

//eslint-disable-line no-restricted-imports
export const experimentalAutomationUsage: ExperimentalQueries['experimentalAutomationUsage'] = (
	_,
	{ cloudId, automationStack, spaceId },
	{ network },
) => {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
	const currentMonth = currentDate.getMonth();

	const spaceScopedUrl = `/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/${spaceId}/highestUsages?limit=100&month=${currentYear}-${currentMonth}`;
	const globalScopedUrl = `/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/rest/GLOBAL/highestUsages?limit=100&month=${currentYear}-${currentMonth}`;

	const scopeUrl = spaceId ? spaceScopedUrl : globalScopedUrl;

	return fetchJSON(network, scopeUrl, {
		method: 'GET',
		credentials: 'include',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then((response) =>
		response.map((rule: any) => ({
			ruleId: rule.ruleId,
			executionCount: rule.executionCount,
		})),
	);
};
